import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const Image = (props) => <LazyLoadImage {...props} threshold={200} />;

export default Image;
